export default "__VITE_ASSET__9edf9e13__"